export const fetchArticles = resp => {
  return {
    type: "FETCH_ARTICLES",
    payload: resp
  };
};
export const setFetching = resp => {
  return {
    type: "SET_FETCHING",
    payload: resp
  };
};
export const resetResources = () => {
  return {
    type: "RESET_RESOURCES"
  };
};



// WEBPACK FOOTER //
// ./src/actions/actions/article.js